import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize, from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
})
export class SignInComponent implements OnInit {
  public signInForm: FormGroup;
  public submittedSignInForm = false;
  public errorLogin: boolean;
  public errorNetwork: boolean;
  public textType: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.prepareSignInForm();
  }

  /**
   * Prepares login form
   */
  prepareSignInForm(): void {
    this.signInForm = this.formBuilder.group({
      username: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$'
          ),
        ],
      ],
      password: ['', Validators.required],
    });
  }

  /**
   * Toggles text type for password field
   */
  toggleTextType(): void {
    this.textType = !this.textType;
  }

  /**
   * Submits login form
   */
  onSubmit(): void {
    this.submittedSignInForm = true;
    if (this.signInForm.valid) {
      this.spinnerService.show();
      from(
        this.authService.retrieveToken(
          this.signInForm.get('username').value,
          this.signInForm.get('password').value
        )
      )
        .pipe(
          switchMap((data) => from(this.authService.retrieveAccount())),
          finalize(() => this.spinnerService.hide())
        )
        .subscribe({
          next: (res) => {
            this.router.navigate(['patients'], {
              queryParams: this.route.snapshot.queryParams,
            });
          },
          error: (err) => {
            if (err == 'Error: unauthorized') {
              this.errorLogin = true;
            } else {
              this.errorNetwork = true;
            }
          },
        });
    }
  }
}
